import React, { useEffect } from 'react';
import OurProducts from './OurProducts';
import ContentPageLayout from './ContentPageLayout';

const OurProductsPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Gift Shop - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Discover our handmade gifts and crafts on Etsy. Unique home décor and custom creations from DeliFeed.');
        }
    }, []);

    return (
        <ContentPageLayout title="Gift Shop">
            <OurProducts />
        </ContentPageLayout>
    );
};

export default OurProductsPage;
